import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import {
  Apps as AppsIcon,
  Download as DownloadIcon,
  TrendingUp as TrendingIcon,
  Today as TodayIcon
} from '@mui/icons-material';
import { downloadAPI } from '../../services/api';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const res = await downloadAPI.getDashboard();
      setStats(res.data.data);
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  const statCards = [
    {
      title: 'Total Software',
      value: stats?.totalSoftware || 0,
      icon: AppsIcon,
      color: '#1976d2'
    },
    {
      title: 'Total Descargas',
      value: stats?.totalDownloads || 0,
      icon: DownloadIcon,
      color: '#388e3c'
    },
    {
      title: 'Descargas Hoy',
      value: stats?.downloadsToday || 0,
      icon: TodayIcon,
      color: '#f57c00'
    },
    {
      title: 'Descargas Esta Semana',
      value: stats?.downloadsThisWeek || 0,
      icon: TrendingIcon,
      color: '#7b1fa2'
    }
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Resumen del Sistema
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        {statCards.map((card, index) => {
          const IconComponent = card.icon;
          return (
            <Grid item xs={12} md={3} key={index}>
              <Card>
                <CardContent>
                  <Box display="flex" alignItems="center">
                    <Box
                      sx={{
                        backgroundColor: card.color + '20',
                        borderRadius: '50%',
                        p: 1,
                        mr: 2
                      }}
                    >
                      <IconComponent sx={{ color: card.color }} />
                    </Box>
                    <Box>
                      <Typography color="textSecondary" gutterBottom>
                        {card.title}
                      </Typography>
                      <Typography variant="h4">
                        {card.value.toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Software más popular */}
      {stats?.popularSoftware && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Software Más Popular
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="h5">
                {stats.popularSoftware.name}
              </Typography>
              <Typography variant="h6" color="primary">
                {stats.popularSoftware.downloadCount} descargas
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default Dashboard;